import React from 'react';

import RightPanel from './RightPanel';
import { useParams, useOutletContext } from 'react-router';

function Project() {
  const { projectId } = useParams();
  const context = useOutletContext();
  const iframeOpacity = context.iframeOpacity;
  const setIframeOpacity = context.setIframeOpacity;
  const setLoading = context.setLoading;
  const project = context.projects.find(({ id }) => id === projectId)?.data;

  return (
    <div className="project-container">
      <div className="filter" />
      {
        project &&
        <>
          <RightPanel
            readme={project.content}
            title={project.title}
          />
          <div className="canvas-wrapper">
            <div className="filter-mobile" />
            <iframe
              className="canvas"
              style={{ opacity: iframeOpacity }}
              title="figma"
              src={project.figmaUrl}
              onLoad={() => { setIframeOpacity(1); setTimeout(() => { setLoading(false) }, 1000) }}
            />
          </div>
        </>
      }
    </div>
  );
}

export default Project;